import { useQuery } from "@tanstack/react-query";
import Portada from "../images/portada.png";
import style from "../styles/head.module.css";

export default function Index() {
   const url = process.env.REACT_APP_URL_DIR + "compania/cia";
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["clientes"],
      queryFn: () =>
         fetch(url, {
            headers: {
               Authorization: `Bearer ${token}`, //mind the space before your token
            },
         }).then((res) => res.json()),
   });

   console.log("compania: ", data);

if (data?.message === "Token inválido"){
   window.location.href = '/login';
}


   return (
      <>
         <div className={style.page}>
            <div className={style.hero_content}>
               <div className={style.hero_text}>
                  <h1>Tattoo & Piercing</h1>
                  <h4>RDM Developments</h4>
                  {data && data?.message !== "Token inválido" ?(
                     <div className={style.nameCia}>
                        <h3>{data[0].razsoc}</h3>
                     </div>
                  ) : null}
                  {/* <br />
                  <a href="#">Ejemplos</a>
                  <a href="#" className="videos">
                     <i className="ri-play-fill"></i>Mira mis videos
                  </a> */}
               </div>
               <div className={style.hero_img}>
                  <img src={Portada} alt="sergie code coding" />
               </div>
            </div>
         </div>
      </>
   );
}
